import * as firebase from 'firebase/app';
import 'firebase/firestore'

let config = {
    apiKey: "AIzaSyCz-lNbu1bgT4VIspqyMq_DRkDROZXwwck",
    authDomain: "newsclassification-7f776.firebaseapp.com",
    databaseURL: "https://newsclassification-7f776.firebaseio.com",
    projectId: "newsclassification-7f776",
    storageBucket: "newsclassification-7f776.appspot.com",
    messagingSenderId: "1038163309783",
    appId: "1:1038163309783:web:d62f14426e71aed8376c92",
    measurementId: "G-8H96JNNKL9"
};

var firebaseApp = null

if (firebase.apps.length>0){
    firebaseApp =  firebase.app();
} else {
    firebaseApp =  firebase.initializeApp(config)
}
export default firebaseApp 
